import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";

const campaigns = [
  {
    title: "Wallbox-Förderung für Mehrfamilienhäuser 2026",
    description:
      "Neue Bundesförderung: 500 Mio. Euro für Wallboxen in Mehrparteienhäusern. Bis zu 2.000 Euro pro Stellplatz. Antrag ab 15. April 2026.",
    image: "https://cocharge.de/images/blog/wallbox-foerderung-mehrfamilienhaus-2026.jpg",
    route: "/campaigns/wallbox-funding",
  },
  {
    title: "Wallbox Photo Frame Overlay",
    description:
      "Upload a station photo, position it inside the cocharge frame, and download a branded image for Google Reviews or social media.",
    image: `${process.env.PUBLIC_URL}/images/cocharge-wallbox-photo-overlay-example.png`,
    route: "/campaigns/wallbox-overlay",
  },
];

const CampaignsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="surface-section p-4">
      <div className="mb-4">
        <h2 className="m-0">Campaigns</h2>
      </div>

      <div className="grid">
        {campaigns.map((campaign) => (
          <div key={campaign.route} className="col-12 md:col-6 lg:col-4">
            <div onClick={() => navigate(campaign.route)} className="cursor-pointer">
              <Card
                className="h-full hover:shadow-4 transition-shadow transition-duration-200"
                header={
                  campaign.image ? (
                    <img
                      src={campaign.image}
                      alt={campaign.title}
                      className="w-full"
                      style={{ height: "180px", objectFit: "cover", borderRadius: "6px 6px 0 0" }}
                    />
                  ) : (
                    <div
                      className="w-full flex align-items-center justify-content-center surface-100"
                      style={{ height: "180px", borderRadius: "6px 6px 0 0" }}
                    >
                      <i className="pi pi-image text-4xl text-color-secondary" />
                    </div>
                  )
                }
              >
                <p className="text-900 font-semibold m-0 mb-2">{campaign.title}</p>
                <p className="text-color-secondary text-sm m-0">{campaign.description}</p>
              </Card>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CampaignsPage;
